module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details Mydetails",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "profile-title details-width"
  }, [_vm._v(_vm._s(_vm.$t('user_center_reset_password')))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "Reset_box"
  }, [_c('div', {
    staticClass: "Reset_list"
  }, [_c('p', {
    staticClass: "Reset_text"
  }, [_vm._v(_vm._s(_vm.$t('user_center_new_password')))]), _vm._v(" "), _c('Input', {
    staticClass: "Reset_input",
    attrs: {
      "placeholder": this.$t('user_center_new_password'),
      "name": "New Password"
    },
    model: {
      value: (_vm.res_psw),
      callback: function($$v) {
        _vm.res_psw = $$v
      },
      expression: "res_psw"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('Input', {
    staticClass: "Reset_input",
    attrs: {
      "placeholder": this.$t('user_center_account_password_re_psw'),
      "name": "Confirm password"
    },
    model: {
      value: (_vm.con_psw),
      callback: function($$v) {
        _vm.con_psw = $$v
      },
      expression: "con_psw"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2%"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.single),
      callback: function($$v) {
        _vm.single = $$v
      },
      expression: "single"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Reset_agree"
  }, [_vm._v(_vm._s(_vm.$t('agree_rule')) + "\n                        "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'terms_of_service'
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('agree_terms_of_conditions')) + "\n                        ")]), _vm._v("\n                        ,\n                        "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'privacy_policy'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('agree_privacy_policy')) + "\n                        ")]), _vm._v("\n                        " + _vm._s(_vm.$t('and')) + "\n                        "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'terms_of_law'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('agree_terms_of_law')) + "\n                        ")]), _vm._v("\n                        .")], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("OK")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71a05f0a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPassword/ResetPassword.vue
// module id = 828
// module chunks = 0